<template>
    <div id="bodiyy" :class="['bodiyy', { 'no-smooth-scroll': isMobile }]" ref="bodx">
        <!-- <Header class="Headersss" style="display: none"></Header> -->
        <Header2 :isScrolled="title.pukititle"></Header2>

        <div class="sections">
            <div class="section green" :class="{ 'scrolled3section': title.pukititle }">
                <div class="fullscreen-video">
                    <video v-if="indexmainvideos"  autoplay muted loop>
                        <!-- <source src="../../assets/test4.mp4" type="video/mp4"/> -->
                          <!-- 使用动态绑定的 indexmainvideos -->
                          <source :src="indexmainvideos" type="video/mp4"/>
                    </video>
                </div>
            </div>
            <div class="section blue" :class="{ 'scrolled3section': title.pukititle }" ref="secondSection">
                <div class="keep1" style=" height: 12vh; text-align: center; display: flex; flex-direction: column;justify-content: center">
                    <p class="sss" style=" margin: 0.5rem;font-size: 30px;font-weight: bold">{{seconds[0].contentzh}}</p>
                    <p class="sss2" style="margin: 0.5rem;color: #808080;font-size: 13px;margin-top: -0.1rem">{{seconds[0].contentcn}}</p>
                </div>

                <div class="bodys">
                    <div class="image-container">
                        <!-- <img src="../../assets/pic2.0-01.jpg" alt="Image 1">
                        <img src="../../assets/pic2.0-02.jpg" alt="Image 1">
                        <img src="../../assets/pic2.0-03.jpg" alt="Image 1">
                        <img src="../../assets/pic2.0-04-04.jpg" alt="Image 1">
                        <img src="../../assets/pic2.0-05.jpg" alt="Image 1"> -->
                        <img
                            v-for="(img, index) in seconds[0].imgs"
                            :key="index"
                            :src="img"
                            alt="Image"
                        />
                    </div>
                </div>
            </div>
            <div class="section red" :class="{ 'scrolled3section': title.pukititle }">
                <div class="keep1" style=" height: 12vh; text-align: center; display: flex; flex-direction: column;justify-content: center;">
                    <p style=" margin: 0.5rem;font-size: 30px;font-weight: bold">{{seconds[1].contentzh}}</p>
                    <p style="margin: 0.5rem;color: #808080;font-size: 13px;margin-top: -0.1rem">{{seconds[1].contentcn}}</p>

                </div>
                <!--            轮播图开始-->
                <div class="bodylunbo1">
                    <div id="app" class="carousel-containerbodylunbo1">
                        <div class="carouselbodylunbo1" :style="{ transform: 'translateX(' + (-currentIndex * 100) + '%)' }">
                            <img v-for="(image, index) in images" :key="index" :src="image.src" :alt="image.alt" class="carousel-imagebodylunbo1">
                        </div>
                        <div class="arrowbodylunbo1 left-arrowbodylunbo1" @click="prevImage">
                            <img src="../../assets/pic-27a.png" alt="左箭头">
                        </div>
                        <div class="arrowbodylunbo1 right-arrowbodylunbo1" @click="nextImage">
                            <img src="../../assets/pic-28a.png" alt="右箭头">
                        </div>
                    </div>
                </div>
                <!--                轮播图结束-->
            </div>

            <div class="section heid1" :class="{ 'scrolled3section': title.pukititle }">
                <div class="content-container">
                    <!-- 文字部分 -->
                    <div class="keep1">
                        <p style="margin: 0.5rem; font-size: 30px; font-weight: bold;">{{seconds[2].contentzh}}</p>
                        <p style="margin: 0.5rem; color: #808080; font-size: 13px;margin-top: -0.1rem;">{{seconds[2].contentcn}}</p>
                    </div>
                    <!-- 图片模块 -->
                    <div class="image-container">
                        <img v-for="(image, index) in seconds[2].imgs" :key="index" :src="image" :alt="`Image ${index + 1}`" />
                    </div>
                </div>
            </div>
<!--            更多咨询的轮播图开始-->
            <div class="section heid" :class="{ 'scrolled3section': title.pukititle }">
                <div class="content-container content-containergengduozixun">
                    <!-- 文字部分 -->
                    <div class="keep12">
                        <p style="margin: 0.5rem; font-size: 30px; font-weight: bold;">{{ isEnglish ?seconds[3].contentcn:seconds[3].contentzh}}</p>
                        <!--  {{ isEnglish ?seconds[3].contentcn: seconds[3].contentzh }}-->
<!--                        <p style="margin: 0.5rem; color: #808080; font-size: 13px;">Flagship Product</p>-->
                    </div>
                    <!-- 轮播图模块模块 -->
                    <div class="carousel-container2">
                        <div class="carousel-track2" :style="{ transform: 'translateX(-' + currentSlide2 * itemWidth2 + 'px)' }">
                            <div class="carousel-item2" v-for="(image, index) in images2" :key="index">
                                <img :src="image.src" :alt="image.caption">
                                <div class="caption2">{{ image.caption }}</div>
                            </div>
                        </div>

                        <!-- Controls -->

                    </div>

                    <img src="../../assets/pic-27a.png" class="carousel-control-prev2" @click="moveSlide(-1)"></img>

                    <img src="../../assets/pic-28a.png" class="carousel-control-next2" @click="moveSlide(1)"></img>
                </div>
            </div>
            <!--            更多咨询的轮播图结束-->



            <div style="height: 3vh;width: 100vw;background-color: white;"></div>
            <div class="section bottomsection">
               
               <Bottom></Bottom>
            </div>
        </div>

        <!-- <Bottom2></Bottom2> -->
<!--        <Bottom></Bottom>-->
    </div>
</template>

<script>
     
    import Bottom from '@/view/public/bottompc.vue';
    import Header2 from '@/view/public/heardpc.vue';
    import axios from 'axios';
    import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下
    import { mapActions, mapState } from 'vuex';
    export default {
        components:{
            // Header,
            // Bottom2,
            Bottom,
            Header2
        },
        data() {
            return {
                indexmainvideos:'',
               
            
                ascription: 'indexmain',  // 可以根据实际需求动态设置

                seconds:
                    [
                    {
                    contentzh:'商务旅行场景应用产品服务',//中文文案
                    contentcn:'Business Travel Products & Seryice for Scenario Applicatio',//英文文案
                    imgs:[
                        //  require('../../assets/pic2.0-01.jpg'),
                        //  require('../../assets/pic2.0-02.jpg'),
                        //  require('../../assets/pic2.0-03.jpg'),
                        //  require('../../assets/pic2.0-04-04.jpg'),
                        //  require('../../assets/pic2.0-05.jpg')
                    ]
                },
                {
                    contentzh:'进取之行',//中文文案
                    contentcn:'Walking with Enterprisinc',//英文文案
                    imgs:[
                        //  require('../../assets/pic2.0-01.jpg'),
                        //  require('../../assets/pic2.0-02.jpg'),
                        //  require('../../assets/pic2.0-03.jpg'),
                        //  require('../../assets/pic2.0-04-04.jpg'),
                        //  require('../../assets/pic2.0-05.jpg')
                    ]
                },
                {
                    contentzh:'旗舰产品',//中文文案
                    contentcn:'Flagship Product',//英文文案
                    imgs:[
                    // require('../../assets/pic-39.jpg'),
                    // require('../../assets/pic-40.jpg')
                    ]
                },
                {
                    contentzh:'更多咨询2',//中文文案
                    contentcn:'Flagship Product',//英文文案
                    imgs:[
                    // require('../../assets/pic-39.jpg'),
                    // require('../../assets/pic-40.jpg')
                    ]
                }
                ],
                isScrolled: false,
                // footerSections: [
                //     {
                //         title: '产品选购',
                //         items: ['P系列', 'U系列', 'K系列', 'E系列', 'C系列', '更多...']
                //     },
                //     {
                //         title: '探索谱褀',
                //         items: ['品牌定位', '研发设计', '绿色智造', '展示中心']
                //     },
                //     {
                //         title: '用户服务',
                //         items: ['售后服务', '联系我们', '常见问题']
                //     },
                //     {
                //         title: '关注谱褀',
                //         items: [
                //             { src: require('../../assets/pic-66.png'), alt: '微信', text: '微信',http:'' },
                //             { src: require('../../assets/pic-67.png'), alt: '小红书', text: '小红书',http:'' },
                //             { src: require('../../assets/facbook.png'), alt: 'facebook', text: 'facebook' ,http:'https://www.facebook.com/profile.php?id=100092522696676'},
                //             { src: require('../../assets/pic-65.png'), alt: '京东', text: '京东',http:'' }
                //         ]
                //     }
                // ],
                currentIndex: 0,
                images: [
                    // { src: require('../../assets/shouyepic-06.jpg'), alt: '商品1' },
                    // { src: require('../../assets/shouyepic07.png'), alt: '商品2' }
                ],
                title: {
                    pukititle: false,
                },
                isMobile: false,
                sections: [],
                showEnglish: false, // 控制是否显示英文
               

                images2: [
                    { src:'', caption: '旗舰工厂' },
                    { src:'', caption: '旗舰工厂' },
                    // { src: require('../../assets/pic-06a.jpg'), caption: '测试' },
                    // { src: require('../../assets/pic-06a.jpg'), caption: '测试' },
                    // { src: require('../../assets/pic-06a.jpg'), caption: '测试' }
                ],
                currentSlide2: 0,
                itemWidth2: 0,

            };
        },
        created() {

            //                  // 在组件加载时获取视频数据
            //  this.getVideosByAscription(this.ascription);
            // this.fetchMenus();  // 组件挂载后请求数据
            
                    },
        computed: {
            // 从 Vuex 的 state 中获取 isEnglish 数据
            ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),
        },

        mounted() {
         
             // 在组件加载时获取视频数据
             this.getVideosByAscription(this.ascription);
            this.fetchMenus();  // 组件挂载后请求数据



            this.initObserver(); // 初始化观察器

            this.calculateWidthAfterLoad();
            this.setItemWidth();
            window.addEventListener('resize', this.setItemWidth);
            this.sections = Array.from(document.querySelectorAll('.section'));
            this.checkIsMobile();
            window.addEventListener('resize', this.checkIsMobile);

            if (!this.isMobile) {
                document.addEventListener('wheel', this.handleScroll, { passive: false });
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setItemWidth);
            document.removeEventListener('wheel', this.handleScroll);
            window.removeEventListener('resize', this.checkIsMobile);
        },
        methods: {

             // 发送请求获取视频数据
             getVideosByAscription(ascription) {
                axios.get(`${apiUrls.baseUrl}/website/api/Pukivideos`, {
                    params: {
                    ascription: ascription
                    }
                })
                .then(response => {
                      // 将响应数据赋值给 videos
                     // 从响应中获取视频 URL 并赋值
                        // const videoUrl = `${apiUrls.devApi}${response.data[0].pukivideos}`;
                        // this.indexmainvideos = videoUrl; // 更新 indexmainvideos
                        // console.log('视频路径:', videoUrl);

                        // 将响应数据赋值给 videos
                        const data = response.data[0];
                    this.indexmainvideos=`${apiUrls.devApi}${data.pukivideos}`;
                    //   console.log("shiping:"+this.indexmainvideos )
                })
                .catch(error => {
                    console.log('请求失败:', error);
                });
                },

            /**
             * 首页的文案数据查询
             */
            async fetchMenus() {
                try {
                    
                    const response = await axios.get(`${apiUrls.baseUrl}/website/api/indexmain`);
                        const dataArray = response.data; // 假设返回的是数组

                        if (dataArray && dataArray.length > 0) {
                        // 遍历所有数据项
                        this.seconds = dataArray.map(item => {
                            // 提取 imgPaths 中的路径列表并转换为数组
                            const imgArray = item.imgPaths.split(','); // 按逗号分割
                            
                            // 使用 map 方法为每个路径加上 devApi 前缀
                            const imgWithPrefix = imgArray.map(img => `${apiUrls.devApi}${img}`);

                            // 返回新的对象，每个对象对应每条数据
                            return {
                            contentzh: item.contentZh, // 中文文案
                            contentcn: item.contentEn, // 英文文案
                            imgs: imgWithPrefix // 处理后的图片数组
                            };
                        });

                         // 找到第二条数据
                        const secondItem = dataArray.find(item => item.contentNumber === 2);

                        if (secondItem) {
                        // 提取第二条数据中的 imgPaths 并转换为数组
                        const imgArray = secondItem.imgPaths.split(',');

                        // 动态更新 images 数组
                        this.images = imgArray.map((imgPath, index) => {
                            return {
                            src: `${apiUrls.devApi}${imgPath}`,  // 为每个图片路径加上 devApi 前缀
                            alt: `商品${index + 1}` // 为每张图片设置 alt 属性
                            };
                        });


                        }
                     // 找到第三条数据
                    const thirdItem = dataArray.find(item => item.contentNumber === 4);

                    if (thirdItem) {
                    // 提取第三条数据中的 imgPaths 并转换为数组
                    const imgArray2 = thirdItem.imgPaths.split(',');

                    // 将逗号分隔的字符串转换为数组
                    const captionsArray = thirdItem.imgDescription.split('，'); // 按中文逗号分割
                    // console.log(captionsArray);
                    

                    // 动态更新 images2 数组 (存储第三条数据)
                    this.images2 = imgArray2.map((imgPath, index) => {
                        return {
                        src: `${apiUrls.devApi}${imgPath}`,  // 为每个图片路径加上 devApi 前缀
                        caption: captionsArray[index] // 为每张图片设置 caption 属性
                        };
                    });

                    // console.log(this.images2); // 检查第三条数据是否赋值成功
                    }
                   
                }
                // console.log(this.seconds)
                } catch (error) {
                    // ___________________________________________________________________
                    
                        this.seconds= 
                    [
                    {
                    contentzh:'商务旅行场景应用产品服务',//中文文案
                    contentcn:'Business Travel Products & Seryice for Scenario Applicatio',//英文文案
                    imgs:[
                         require('../../assets/pic2.0-01.jpg'),
                         require('../../assets/pic2.0-02.jpg'),
                         require('../../assets/pic2.0-03.jpg'),
                         require('../../assets/pic2.0-04-04.jpg'),
                         require('../../assets/pic2.0-05.jpg')
                    ]
                },
                {
                    contentzh:'进取之行',//中文文案
                    contentcn:'Walking with Enterprisinc',//英文文案
                    imgs:[
                         require('../../assets/pic2.0-01.jpg'),
                         require('../../assets/pic2.0-02.jpg'),
                         require('../../assets/pic2.0-03.jpg'),
                         require('../../assets/pic2.0-04-04.jpg'),
                         require('../../assets/pic2.0-05.jpg')
                    ]
                },
                {
                    contentzh:'旗舰产品',//中文文案
                    contentcn:'Flagship Product',//英文文案
                    imgs:[
                    require('../../assets/pic-39.jpg'),
                    require('../../assets/pic-40.jpg')
                    ]
                },
                {
                    contentzh:'更多咨询2',//中文文案
                    contentcn:'Flagship Product',//英文文案
                    imgs:[
                    require('../../assets/pic-39.jpg'),
                    require('../../assets/pic-40.jpg')
                    ]
                }
                ],

                this.images= [
                    { src: require('../../assets/shouyepic-06.jpg'), alt: '商品1' },
                    { src: require('../../assets/shouyepic07.png'), alt: '商品2' }
                ],



                this.images2= [
                    { src: require('../../assets/pic-10.jpg'), caption: '旗舰工厂' },
                    { src: require('../../assets/pic-09.jpg'), caption: '谱祺品牌展示中心' },
                    { src: require('../../assets/pic-11.jpg'), caption: '国际展会' },
                    { src: require('../../assets/pic-11.jpg'), caption: '国际展会2' },
                   
                ],

                     // ___________________________________________________________________
                    console.error('Error fetching menus:', error);
                    }
              },


            initObserver() {
                // console.log("-----3------")
                // console.log(this.isEnglish)
                const options = {
                    root: this.$refs.bodx,
                    rootMargin: '0px',
                    threshold: 0.1 // 10% 进入视口时触发
                };
// 只观察第二个 section
                // 只观察第二个 section
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            // this.title.pukititle = true; // 当第二个 section 进入视口时设置 isScrolled = true
                        }
                    });
                }, options);
                const secondSection = this.$refs.secondSection; // 监视第二个 section
                if (secondSection) {
                    observer.observe(secondSection);
                }

            },
            

            clickLang(type) {

                if (type === 1 ) {
                    this.showEnglish = false; // 切换语言状态
                    this.$i18n.locale = 'zh'
                    const bodyElement = document.body;
                    bodyElement.style.fontFamily = 'MiSans-Normal';

                } else if (type === 2) {
                    this.showEnglish = true; // 切换语言状态
                    this.$i18n.locale = 'en'
                    const bodyElement = document.body;
                    bodyElement.style.fontFamily = 'Montserrat-Normal';
                }

            },
            //跳转到产品查询页面
            opens(id){
                if(id==='facebook'){
                    window.open('https://www.facebook.com/profile.php?id=100092522696676', '_blank');
                }
                if(id === 'collectionA' || id === 'collectionB' || id === 'collectionC') {
                    this.$router.push({ name: 'products', params: { id: id } });
                    // window.location.reload()// 调用刷新方法

                }
                if(id==='main' &&this.$route.name !== 'main'){
                    // 或者如果你使用命名路由

                        this.$router.replace({name: 'main'})


                }
                if(id===1 &&this.$route.name !== 'searchnew'){
                    // 或者如果你使用命名路由

                    this.$router.push({name: 'searchnew'})


                }
                if(id==='greenmanufacturing' &&this.$route.name !== 'greenmanufacturing'){
                    // 或者如果你使用命名路由

                    this.$router.push({name: 'greenmanufacturing'})


                }
                if(id==='aftersales' &&this.$route.name !== 'aftersales'){
                    // 或者如果你使用命名路由

                    this.$router.push({name: 'aftersales'})


                }


            },
            mingheng(){

                    window.location.href = 'https://www.mingheng-group.com/';

            },
            prevImage() {
                if (this.currentIndex > 0) {
                    this.currentIndex--;
                } else {
                    this.currentIndex = this.images.length - 1;
                }
            },
            nextImage() {
                if (this.currentIndex < this.images.length - 1) {
                    this.currentIndex++;
                } else {
                    this.currentIndex = 0;
                }
            },
            debounce(func, wait) {
                let timeout;
                return function (...args) {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(context, args), wait);
                };
            },
            handleScroll(event) {
                if (this.isMobile) return;
                event.preventDefault();

                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                const currentSectionIndex = this.sections.findIndex((section) => {
                    const rect = section.getBoundingClientRect();
                    return rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2;
                });

                // 检查滚动位置并设置 isScrolled
                if (currentSectionIndex > 0)  {
                    this.title.pukititle = true;
                } else {
                    this.title.pukititle = false;
                }



                if (currentSectionIndex !== -1) {
                    if (event.deltaY > 0) {
                        if (currentSectionIndex < this.sections.length - 1) {
                            this.scrollToSection(currentSectionIndex + 1);
                        }
                    } else {
                        if (currentSectionIndex > 0) {
                            this.scrollToSection(currentSectionIndex - 1);
                        }
                    }
                }
            },
            handleScroll1() {
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                const firstSection = this.sections[0];
                const rect = firstSection.getBoundingClientRect();
                this.title.pukititle = !(rect.top <= 0 && rect.bottom >= 0);
            },
            scrollToSection(index) {
                this.sections[index].scrollIntoView({ behavior: 'smooth' });
            },
            checkIsMobile() {
                this.isMobile = window.innerWidth <= 768;
                if (this.isMobile) {
                    document.removeEventListener('wheel', this.handleScroll);
                } else {
                    document.addEventListener('wheel', this.handleScroll, { passive: false });
                }
            },
            // 确保图片加载完成后再计算宽度
            calculateWidthAfterLoad() {
                const images = document.querySelectorAll('.carousel-item2 img');
                let loadedCount = 0;

                images.forEach((img) => {
                    img.onload = () => {
                        loadedCount++;
                        if (loadedCount === images.length) {
                            this.setItemWidth(); // 所有图片加载完后计算宽度
                        }
                    };
                });
            },
            setItemWidth() {
                // 计算单个轮播项的宽度（包含 margin）
                const carouselItem = document.querySelector('.carousel-item2');
                this.itemWidth2 = carouselItem ? carouselItem.offsetWidth + 20 : 0; // 包含 20px margin-right
            },
            moveSlide(direction) {
                // 图片总数
                const totalSlides = this.images2.length;
                // 可见图片数量
                const visibleItems = 3;
                // 计算最大滑动次数
                const maxSlideIndex = totalSlides - visibleItems;

                // 更新当前滑动的索引
                this.currentSlide2 += direction;

                // 限制索引在范围内循环
                if (this.currentSlide2 < 0) {
                    this.currentSlide2 = maxSlideIndex; // 回到最后一个可见位置
                } else if (this.currentSlide2 > maxSlideIndex) {
                    this.currentSlide2 = 0; // 回到第一个图片
                }
            }

        },
    };
</script>


<style scoped>

/*    更多咨询模块的位置调整开始*/
.content-containergengduozixun{
    margin-bottom: 5rem;
}
/*    更多咨询模块的位置调整结束*/
/*    底部版本声明开始*/
.leftbottomp{
    margin-left: 2rem!important;
}
.footer-text{
    width: 21rem;
    margin: 0;
    text-align: center; /* Center align the copyright text */
}
.footer-info {
    display: flex;
    justify-content: center; /* Center align the items horizontally */
    gap: 5rem; /* Adjust the gap between items as needed */
}

.footer-item {
    margin: 0;
}
/*底部版本声明结束*/
    /*<!--            更多咨询的轮播图开始-->*/
    .carousel-container2 {
        position: relative;
        width: 100%;
        max-width: 1300px;
        margin: auto;
        overflow: hidden;
    }
/* 适用于屏幕宽度大于等于 2560px 的大屏幕 */
@media (min-width: 2560px) {
    .carousel-container2 {
        max-width: 2100px;
    }
    .footer-container {
  
 
   
  
   
}
}

    .carousel-track2 {
        display: flex;
        transition: transform 0.5s ease;
    }

    .carousel-item2 {

        /*min-width: calc(33.33% - 20px); !* 维持三列布局 *!*/
        /*margin-right: 20px; !* Add space between the items *!*/
        flex: 1 0 calc(33.33% - 19px); /* 每张图片占三分之一，并且考虑20px的间距 */
        margin-right: 20px; /* 图片之间的间距 */
        box-sizing: border-box; /* 确保 padding 和 margin 都包含在宽度内 */

    }
.carousel-item2:last-child {
    margin-right: 0; /* 最后一张图片没有右侧间距 */
}

    .carousel-item2 img {
        /*width: 100%;*/
        /*height: 21rem;  !* 图片高度充满容器 *!*/
        /*object-fit: cover;  !* 保持图片比例，填充整个容器，裁剪不适合的部分 *!*/
        width: 100%;
        height: auto; /* 根据宽度自动调整高度 */
        object-fit: cover; /* 保持图片比例并裁剪 */
        aspect-ratio: 1.2/1; /* 可选：保持宽高比，如16:9 */
    }
    .carousel-item2 .caption2 {
        /*position: absolute;*/

        /*background-color: rgba(0, 0, 0, 0.6); !* 半透明背景，使文字可见 *!*/
        color: #606266;
        margin-top: 1rem;
        font-size: 0.9rem;
        border-radius: 5px; /* 可选：让背景的边角稍微圆润 */
        text-align: left; /* 左对齐 */
        box-sizing: border-box;

    }

    .carousel-control-prev2,
    .carousel-control-next2 {
        position: absolute;
        top: 48%;
        transform: translateY(-8%);
        /*background-color: rgba(0, 0, 0, 0.5);*/
        color: white;
        padding: 10px;
        cursor: pointer;
        z-index: 10;
        width: 3rem;
    }

    .carousel-control-prev2 {
        left: 2rem;
    }

    .carousel-control-next2 {
        right: 2rem;
    }

    /*<!--            更多咨询的轮播图结束-->*/
    .heid{
       
        display: flex;
        justify-content: center; /* 水平居中内容容器 */
        align-items: center; /* 垂直居中内容容器 */
        margin-bottom: 2rem;
       
        
    }

    .content-container {
        display: flex;
        flex-direction: column; /* 垂直排列文字和图片模块 */
        align-items: center; /* 水平居中内容 */
        text-align: center; /* 文字居中对齐 */
        gap: 1rem; /* 文字和图片之间的间距 */
    }
    .keep {
        height: 12vh; /* 根据需要调整 */
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .content-container .image-container {
        display: flex;
        justify-content: space-between;
        width: 100%; /* 容器宽度 */
        /*max-width: 100rem; !* 限制图片宽度，避免过宽 *!*/
    }

     .content-container .image-container img {
        width: 50%; /* 确保两张图片各占宽度的一半 */
        height: 47%;;
    }

    /*    视频样式开始，*/
/* 容器样式 */
.fullscreen-video {
    position: absolute; /* 确保容器覆盖整个视口 */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;  /* 高度为100vh，确保视频全屏 */
    overflow: hidden; /* 隐藏溢出部分 */
}

/* 视频样式 */
.fullscreen-video video {
    position: absolute; /* 确保视频填充容器 */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;  /* 高度为100vh，确保视频全屏 */
    object-fit: cover; /* 保持比例并裁剪 */
}

/*视频样式结束*/
/*    网页底部开始*/

/*    底部页脚开始*/
footer {
    /* margin-top: 12vh; */
    background-color: #000;
    color: #fff;
   
    width: 100vw; /* 确保宽度适应视口 */
    overflow-y: hidden;
}


.footer-container {
    margin: 0 auto; /* 自动居中 */
    display: flex;
    justify-content: space-between; /* 控制集合之间的水平间距 */
    flex-wrap: wrap;
    padding: 0 10rem; /* 增加内边距，确保离屏幕两端有足够的间距 */
    /* margin-right: -2rem; */
    margin-top: -6rem;
}

.footer-section {
    flex: 1;
    min-width: 150px; /* 设置最小宽度 */
    text-align: center; /* 确保内容左对齐 */
    margin: 15px 8px; /* 减少集合的外边距 */
}

.footer-section h3 {
    font-weight: lighter;
    font-size: 0.8rem;
    color: #d3cece;
    padding-bottom: 8px; /* 减少下内边距 */
    margin-bottom: 8px; /* 减少下外边距 */
    /*text-align: center; !* 标题左对齐 *!*/
    margin-right: 6rem;
}

.footer-section ul {
    list-style: none;
    padding: 0;
    margin: 0; /* 移除外边距 */
    text-align: center; /* 列表内容左对齐 */
}

.footer-section ul li {
    color: #9b9797;
    font-weight: 200;
    font-size: 1.2rem;
    margin-bottom: 16px; /* 减少列表项之间的间距 */
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    padding-left: 5rem; /* 向右移动列表项，调整这个值来控制移动距离 */
}

.footer-section ul li img {
    width: 20px; /* 调整图标大小 */
    height: 20px;
    margin-right: 6px; /* 减少图标与文本之间的间距 */
}

.social-links {
    padding: 0;
    list-style: none;
}

.social-links li {
    display: flex;
    align-items: center;
    margin-bottom: 5px; /* 减少列表项之间的间距 */
}

.social-links li img {
    width: 25px; /* 调整图标大小 */
    height: 25px;
    margin-right: 6px; /* 减少图标与文本之间的间距 */
}


.footer-bottom {
    margin-top: 2rem;
    font-size: 0.9rem;
    color: #9b9797;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    /*border-top: 1px solid #fff;*/
    text-align: center;
}

.footer-bottom-left,
.footer-bottom-right {
    flex: 1;
    /*align-items: flex-start; !* Align items to the start of the flex container (left-align) *!*/
    margin-right: 2rem;
}


.footer-bottom-center {
    flex: 0;
}

.footer-bottom-center img {
    height: 30px; /* 根据需要调整高度 */
    width: 40px;
}
.footer-bottom p {
    margin: 5px 0;
}
/*    底部页脚结束*/
/*网页底部结束*/
    .endman{
        background-color: white;
        display: flex;
        flex-direction: column; /* 垂直排列 */

    }
/*    网页三张图开始*/
    .bodyend {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 60vh;
        margin: 0;
        background-color: #fff;
    }
    .bodyend .container {
        display: flex;
        gap: 30px;
    }
    .bodyend .image-box {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
    }
    .bodyend .image-box img {
        width: 25rem;
        height: auto;
    }
    .bodyend  .text-box {
        margin-top: 0.3rem;
    }
    .bodyend .text-box p
        /*    网页三张图结束*/
    /*    輪播圖開始*/
/*  轮播图1开始*/
bodylunbo1 {
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*height: 100%;*/
    /*margin: 0;*/
    /*background-color: #f0f0f0;*/
        display: flex;
        justify-content: center; /* 水平居中轮播图 */
        align-items: center;
        margin: 0 auto;
        position: relative;
        width: 100%; /* 根据需要调整宽度 */
        max-width: 90%; /* 限制轮播图最大宽度 */


}
    .keep12{
      margin-bottom: 1rem;
    }
.keep1{
    margin-top: 2rem;
}
.carousel-containerbodylunbo1 {
    /*position: relative;*/
    /*width: 70%;*/
    /*overflow: hidden;*/
    position: relative;
    overflow: hidden;
    width: 100%; /* 缩减轮播图的宽度为父容器的60% */
    max-width: 100vw; /* 可以设置一个最大宽度，限制轮播图的宽度 */
    margin: 0 auto; /* 保证轮播图居中 */
    /*margin-bottom: 1rem; !* 增加底部的间距 *!*/
}

.carouselbodylunbo1 {
    display: flex;
    transition: transform 0.5s ease-in-out;
}

.carousel-imagebodylunbo1 {
    /*margin-top: 2rem;*/
    flex-shrink: 0;
    width: 100%;
    height: 75vh;
    object-fit: cover;
}

.arrowbodylunbo1 {

    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 10;
}

.left-arrowbodylunbo1 {

    left: 138px;
}

.right-arrowbodylunbo1 {
    right: 138px;
}
.arrowbodylunbo1 img{
    width: 2rem;
    height: 2rem;
}
/*輪播圖結束*/

/*    首页五张图片的样式开始*/
/*    首页四张图片展示的样式*/
.bodys {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3vh;
    height: 60vh;

    margin-right: 2vh;
    background-color: white;
    width: auto;
}
.bodys .image-container {
    display: flex;
    gap: 0.2rem;
}
.bodys .image-container img {
    /* width: 18.5rem; */
    width: 17vw;
    /*transition: box-shadow 0.3s ease;*/
}

.bodys .image-container img:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}
/*首页五张图片的样式结束*/
    .bodiyy {
        height: 100vh;
        width: 100vw;
        display: flex;
        flex-direction: column;
       
        /*margin: 0;*/
        /*padding: 0;*/
        overflow: hidden;
    }

    /*导航栏开始*/
    .header .vertical-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }

    .imghead,
    .headcont {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border-bottom: 1px solid #b9b7b7;
    }

    .imghead img {
        height: 3vh;
    }

    .headcont {
        justify-content: space-around;
        width: 100%;
        text-align: center;
    }

    .header {
        transition: height 1s ease-in-out;
        height: 16vh;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        position: sticky;
        top: 0;
        z-index: 1;
        margin: 0;
        padding: 0;
    }

    .nav-list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        position: relative;
    }

    .nav-item {

        margin: 0 50px;
        cursor: pointer;
    }

    .submenu {
        display: none;
        position: absolute;
        top: 100%;
        left: calc(50% - 51rem); /* 使菜单居中于父元素 */
        background-color: white;
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0);
        list-style: none;
        padding: 10px;
        margin: 0;
        width:100rem; /* 子菜单宽度 */
        height: 35vh;


    }
    /*没有子菜单就隐藏开始*/
    .nav-item:hover .submenuhead{
        display: none!important;
    }
        /*没有子菜单就隐藏结束*/
    .nav-item:hover .submenu {
        display: flex;
        justify-content: center; /* 水平居中对齐子菜单项 */
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
    }
    .nav-item:hover .span1head {
        font-weight: bold;
    }

    .submenu-item {
        display: flex;
        flex-direction: column; /* 设置为上下排列 */
        align-items: center; /* 水平居中 */
        justify-content: center; /* 垂直居中 */
        /*text-align: center; !* 文字居中对齐 *!*/
        padding: 10px; /* 调整内边距 */
        margin: 0 8px; /* 减少外边距，缩短间距 */

        text-align: left; /* 文字左对齐 */

    }

    .submenu-img {

        height: 25vh;
        /*margin-right: 2vw;*/
        margin-bottom: 10px; /* 图片与文字之间的距离 */

    }

    .submenu-text {
font-size: 0.8rem;
width: 5vw;
        /*margin-right: 6vw;*/
        margin-right: -2vw;
       /*margin-top: 0.2rem;*/
        font-weight: 300;
        color: #808080;
    }
    /*导航栏结束*/

    /* 导航栏滑动样式开始 */
    .scrolled3headimg {

        transition: display;
        display: none;

    }
    .scrolled3headcont {}

    .scrolled3head {
        /*max-height: 0;*/
        /*overflow: hidden; !* 确保内容在 max-height 为 0 时被隐藏 *!*/
        transition: height 1s ease-in-out; /* 过渡动画 */
        height: 8vh;
    }
    /* 导航栏滑动样式结束 */
    /*滑动logo开始*/
    .scrolled3logo{
        display: block!important;
        transition: top 1.3s ease-in-out; /* 过渡动画 */
        top: 1rem!important;
    }
    /*滑动logo结束*/
    /*滑动网页内容样式开始*/
    .scrolled3section {
        height: calc(100vh - 3vh) !important;
    }
    /*滑动网页内容样式结束*/
    .sections {
        flex: 1;
        overflow: hidden;
        margin: 0;
        padding: 0;
    }

    .section {
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        height: calc(100vh - 16vh);
        width: 100vw;
        box-sizing: border-box;
        position: relative;
        margin: 0;
        padding: 0;
    }

    .green {
        background-color: #e6eae6;
    }

    .blue {
        background-color: white;
        display: flex;
        flex-direction: column; /* 子容器上下排列 */
        padding-bottom: 5rem;
    }

    .red {
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
        gap: 1rem; /* 两者之间增加20px的距离 */
        text-align: center; /* 水平居中整个 section */
    }

    
   

/* 针对更大的台式电脑（如 1920px 以上） */
@media (min-width: 1920px) {
    /* 在此范围内的样式 */
    .bottomsection{
      height: 100vh;
      background-color: black;
      width: calc(100vw - 17px); /* 17px 是常见的滚动条宽度，可以根据实际情况调整 */
        overflow: hidden;
     
  }
}

/*头部手机端样式开始*/
@media screen and (max-width: 600px) {
    .carousel-control-prev2,.carousel-control-next2{
        width: 2rem;
    }
    .carousel-control-prev2 {
        top: 7rem;
        left: 0.1rem;
    }

    .carousel-control-next2 {
        top: 7rem;
        right: 1rem;
    }
    .bodys{
        height: auto;
    }

    .bodys .image-container img{
        width: 4.5rem;
    }
    .bottomsection{
      
        height: 0vh;
    }
    .heid1{
        height: 18rem;
        padding-bottom: 2rem;
    }
    .heid{
        height: 20rem;
       
    }
  
    .keep1{
        height: auto!important;
        margin-top: 0rem;
    }
    .keep1 .sss{
        font-size: 20px!important;
    }
    .keep1 .sss2{
        font-size: 10px!important;
    }
    .Headersss{
        display: block!important;
        position: sticky!important;
    }
   
    .image-box{
        flex:1
    }
    .text-box-p2{
        font-size: 15px
    }
    .text-box-p1{

        font-size: 8px!important;
    }
    .endman .contentpng433{
       height: 10rem!important;
    }
    .endman{
        height: 100rem;
        /*margin-top: 10rem;*/
        padding-top: 14rem;
    }


    .right-arrowbodylunbo1{
        right: 1rem;
    }
    .left-arrowbodylunbo1{
        left: 0.2rem;
    }
    .red{
        height: 20rem;
    }
    .carousel-containerbodylunbo1 {
        width: 100%; /* 占满屏幕宽度 */
        max-width: none; /* 移除最大宽度限制 */
    }
    .carousel-imagebodylunbo1 {
        width: 100%;
        height: auto; /* 自适应高度 */
        max-height: 60vh; /* 根据需要调整最大高度 */

    }
    .carousel-bodylunbo1 {
        width: 100%; /* 容器宽度 */
    }

    .bodiyy{
    all: unset; /* 重置所有继承和自身的样式 */
}
.header{
display: none;
}
.green{
    all:unset;
    height: 45rem;
}
.fullscreen-video{
    position: relative; /* 确保内容相对定位 */
    width: 100vw; /* 宽度占满视口宽度 */
    height: 30vh; /* 高度占满视口高度 */
    overflow: hidden; /* 确保内容溢出时隐藏 */
    background-color: #000; /* 可选：设置背景颜色，通常为黑色 */
}
.fullscreen-video video{
    position: absolute; /* 绝对定位 */
    top: 50%;
    left: 50%;
    width: 100%; /* 宽度占满容器 */
    height: 100%; /* 高度占满容器 */
    object-fit: cover; /* 保持视频比例并覆盖容器 */
    transform: translate(-50%, -50%); /* 通过偏移量居中视频 */
}
.image-container{
    /*margin-top: -80rem;*/
    gap: 1px;
    /* margin-bottom: 10rem; */
}
.blue{
    
   padding-top: 2rem;
    height: auto;
    margin-bottom: 0rem;
    padding-bottom: 0rem;
    
}


}

/*手机端样式结束*/
/*手机段样式结束*/
</style>

